import request from '@/utils/request'




/**
 * 获取静态数据
 * @param data
 */
export function getStaticData(params) {
  return request({
    url: '/static/getStaticData',
    method: 'get',
    params: params
  })
}















// WEBPACK FOOTER //
// ./src/api/staticData.js